import * as React from 'react';
import './App.css';
import Root from './components/Root';
import { BrowserRouter } from 'react-router-dom';
import { MuiThemeProvider, CssBaseline, createMuiTheme } from '@material-ui/core';
import { StripeProvider } from 'react-stripe-elements';
import 'react-image-lightbox/style.css';
const theme = createMuiTheme({
	typography: {
	},
	palette: {

	}
});
(window as any).FB.init({
	version: `v3.1`,
	appId: '359193168169308',
	xfbml: false,
	cookie: false
});
class App extends React.Component {

	public render() {
		return (
			<BrowserRouter>
				<MuiThemeProvider theme={theme}>
					<CssBaseline />
					<StripeProvider apiKey={process.env.REACT_APP_STRIPE_TOKEN!}>
						<Root />
					</StripeProvider>
				</MuiThemeProvider>
			</BrowserRouter>
		);
	}
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx